import React from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../../components/ui/LoadingSpinner';
import { DraggableStatistics } from '../../components/dashboard/DraggableStatistics';

export interface StatisticsConfig {
  citasPorMes?: boolean;
  cancelacionesPorMes?: boolean;
  topTratamientos?: boolean;
  rankingProfesionales?: boolean;
  distribucionGenero?: boolean;
  distribucionEdad?: boolean;
  ingresosTratamiento?: boolean;
  citasVsCancelaciones?: boolean;
  horasPico?: boolean;
}

interface StatisticsPageProps {
  config?: StatisticsConfig;
  showHeader?: boolean;
  isLoading?: boolean;
}

export function StatisticsPage({ 
  config = {
    citasPorMes: true,
    cancelacionesPorMes: true,
    topTratamientos: true,
    rankingProfesionales: true,
    distribucionGenero: true,
    distribucionEdad: true,
    ingresosTratamiento: true,
    citasVsCancelaciones: true,
    horasPico: true
  },
  showHeader = true,
  isLoading = false
}: StatisticsPageProps) {
  const { t } = useTranslation();

  // Contar cuántas estadísticas están seleccionadas
  const selectedCount = Object.values(config).filter(Boolean).length;
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" text={t('dashboard.loadingStats')} />
      </div>
    );
  }
  
  if (selectedCount === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-400 dark:text-gray-500 mb-4">
          <svg className="mx-auto h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
          No hay estadísticas seleccionadas
        </h3>
        <p className="text-gray-500 dark:text-gray-400">
          Selecciona al menos una estadística para visualizar los datos
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      {showHeader && (
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
            {t('navigation.statistics')}
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Análisis detallado de datos y tendencias de la clínica
          </p>
        </div>
      )}

      {/* Componente de estadísticas con drag and drop */}
      <DraggableStatistics config={config} />
    </div>
  );
} 